import React, { Component } from 'react';
import { connect } from 'react-redux';
import withAuth from '../../../../components/Services/WithAuth';
import { setPageView } from '../../../../components/GoogleAnalytics/index';
import { fetchMisFields, setMisFieldSetup, fetchMisFieldsByCorporateId, fetchDefaultMisFields } from '../action';
import CorporateModal from '../../../../components/UI/CorporateModal/index';
import Modal from '../../../../components/UI/Modal/Modal';
import { fetchIsMisOrderIdMandatoryByCorporateId ,setIsMandatoryMisOrderId } from '../../../Corporate/Create/action'
import {
    Col, Row, Card, CardBody,
    Button, ModalBody, ModalHeader,
    ModalFooter, Label, Input, Form, FormGroup
} from 'reactstrap';

import MultiSelect from '../../../../components/ReusableComponents/MultiSelect/index';

class MisFieldSetup extends Component {
    constructor() {
        super();
        this.state = {

            misFieldLookUptable: new Map(),
            tempSelectedMisFields: [],
            selectedMisFieldNamesForDisplay: [],
            showModal: false,
            body: null,
            showCorporateModal: false,
            corporateModalType: "",
            isMandatoryMisOrderId: true
        }
    }

    componentDidMount() {
        setPageView('/Admin/create/corporate/misFieldsetup', document.location.href)
        this.props.activeProgressTab('setup-progress-element current');
        if (!this.props.misFieldList || this.props.misFieldList.length===0) {
            this.props.fetchMisFieldList();
        }
        if(!this.props.defaultMisFieldList || this.props.defaultMisFieldList.length==0)
        {
            this.props.fetchDefaultMisFields();
        }
       if(!this.state.misFieldLookUptable || this.state.misFieldLookUptable.size===0)
        {
            if(this.props.defaultMisFieldList && this.props.defaultMisFieldList.length>0)
            {
                this.initializeMap(this.props.defaultMisFieldList);
            }
            if(this.props.misFieldList && this.props.misFieldList.length>0)
            {
                this.initializeMap(this.props.misFieldList);
            }
        }

        if (this.props.match.params.corporateId && (!this.props.misFieldSetupData || this.props.misFieldSetupData.length === 0)) {
            this.props.fetchMisFieldsByCorporateId(this.props.match.params.corporateId);
        }
        else {
            const tempArr = this.getMisNames();
            var tempMap = this.getUpdatedMapWithLatestDisplayType();
            this.setState(prevState => ({
                selectedMisFieldNamesForDisplay: tempArr,
                misFieldLookUptable: tempMap
            }))
        }
      
        if(!this.props.fetchIsMisOrderIdMandatorySuccess && this.props.match.params.corporateId){
            this.props.fetchIsMisOrderIdMandatoryByCorporateId(this.props.match.params.corporateId);
        }

    }

    componentDidUpdate(prevProps) {
        const { misFieldList, misFieldSetupData } = this.props;
        if (misFieldList && misFieldList!==prevProps.misFieldList) {
            this.initializeMap(this.props.misFieldList);
        }

        if (this.props.misFieldSetupData !== prevProps.misFieldSetupData) {
            const tempArr = this.getMisNames();
            var tempMap = this.getUpdatedMapWithLatestDisplayType();
            this.setState({
                selectedMisFieldNamesForDisplay: tempArr,
                misFieldLookUptable: tempMap
            });
        }

        if(this.props.defaultMisFieldList && this.props.defaultMisFieldList!==prevProps.defaultMisFieldList)
        {
           this.initializeMap(this.props.defaultMisFieldList);
        }
        if (this.props.fetchIsMisOrderIdMandatorySuccess != undefined && this.props.fetchIsMisOrderIdMandatorySuccess !== prevProps.fetchIsMisOrderIdMandatorySuccess) {
            this.setState({
                isMandatoryMisOrderId: this.props.fetchIsMisOrderIdMandatorySuccess
            });
        }
    }

    initializeMap=(list)=>{
        if(list && list.length>0)
        {
        var tempMap = this.state.misFieldLookUptable;
        for (let misField of list) {
            if (misField) {
                if(!misField.displayType)
                    misField.displayType="INTERNAL";
                if(misField.name && !tempMap.has(misField.name))
                tempMap.set(misField.name, misField);

            }
               
        }
        this.setState({
            misFieldLookUptable: tempMap
        });
    }
    }

    initializeMap = (list) => {
        if (list && list.length > 0) {
            var tempMap = this.state.misFieldLookUptable;
            for (let misField of list) {
                if (misField) {
                    if (!misField.displayType)
                        misField.displayType = "INTERNAL";
                    if (misField.name && !tempMap.has(misField.name))
                        tempMap.set(misField.name, misField);

                }

            }
            this.setState({
                misFieldLookUptable: tempMap
            });
        }
    }

    getUpdatedMapWithLatestDisplayType = () => {
        var tempMap = this.state.misFieldLookUptable;
        for (let misField of this.props.misFieldSetupData) {
            if(misField && misField.name && misField.displayType){
                tempMap.set(misField.name,misField) ;
            }   
        }
        return tempMap;
    }

    handleToggle = () => {
        this.setState(prevState => ({
            showCorporateModal: !prevState.showCorporateModal,
            tempSelectedMisFields: []
        }))
    }
    handleCancel = () => {
        this.handleToggle();
    }
    handleDelete = (event, misFieldNameToDelete) => {
        const tempArr = Array.from(this.state.selectedMisFieldNamesForDisplay);
        const index = tempArr.indexOf(misFieldNameToDelete);
        if (index > -1) {
            tempArr.splice(index, 1);
            this.setState({
                selectedMisFieldNamesForDisplay: tempArr
            })
        }
    }
    getMisNames = () => {
        var tempArr = [];
        for (let misField of this.props.misFieldSetupData) {
            if (misField)
                tempArr.push(misField.name);
        }
        return tempArr;
    }

    selectedEntityCallbackForMisFieldAddition = (selectedMisData) => {
        this.setState({
            tempSelectedMisFields: selectedMisData
        })
    }

    handleAddMisFields = () => {
        if (this.state.tempSelectedMisFields.length == 0) {
            return;
        }
        for (let i = 0; i < this.state.tempSelectedMisFields.length; i++) {
            if (!this.state.selectedMisFieldNamesForDisplay.includes(this.state.tempSelectedMisFields[i].label)) {
                this.state.selectedMisFieldNamesForDisplay.push(this.state.tempSelectedMisFields[i].label);
            }
        }
        this.handleToggle();
    }
    toggleModal = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
            body: null
        }));
    }
    getSelectedMisfieldObjectList = () => {
        const tempArr = [];
        for (let misFieldName of this.state.selectedMisFieldNamesForDisplay) {
            if(misFieldName && this.state.misFieldLookUptable && this.state.misFieldLookUptable.has(misFieldName))
                tempArr.push(this.state.misFieldLookUptable.get(misFieldName))
        }
        return tempArr;
    };

    handleMisNextButton = () => {

        if (this.state.selectedMisFieldNamesForDisplay.length > 0 || !this.props.misFieldList || this.props.misFieldList.length === 0) {
            this.props.setMisFieldSetup(this.getSelectedMisfieldObjectList());
            this.props.setIsMandatoryMisOrderId(this.state.isMandatoryMisOrderId);
            this.props.activeProgressTab('setup-progress-element finished');
            this.props.history.push('../scorecardsetup');
        }
        else {
            this.setState(prevState => ({
                showModal: !prevState.showModal,
                body: <div>
                    <ModalHeader>Warning</ModalHeader>
                    <ModalBody>
                        <p className="alert alert-warning"><i className="fa fa-exclamation-circle orange"></i>&nbsp;&nbsp; Add Mis Fields To Continue</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="info" onClick={this.toggleModal}>Ok</Button>
                    </ModalFooter>
                </div>
            }))
        }

    }
    handleAdd = () => {
        this.handleToggle();
    }
    handleAddDefaultMisFields = () => {
        if(this.props.defaultMisFieldList && this.props.defaultMisFieldList.length>0)
        {
            var tmp=this.state.selectedMisFieldNamesForDisplay?this.state.selectedMisFieldNamesForDisplay:[];
            for (let i = 0; i < this.props.defaultMisFieldList.length; i++) {
                if (this.props.defaultMisFieldList[i]&& !tmp.includes(this.props.defaultMisFieldList[i].name)) {
                    tmp.push(this.props.defaultMisFieldList[i].name);
                }
            }
            this.setState({
                selectedMisFieldNamesForDisplay:tmp
            })
        }
    }
    getListStyle = () => ({
        background: "lightblue",
        padding: 5,
        width: 550,
        height: 300,
        overflowY: 'scroll'
    });

    getItemStyle = () => ({
        // some basic styles to make the items look a bit nicer
        userSelect: "none",
        padding: 10,
        margin: 5,
        width: 440,
        border: "groove",
        // change background colour if dragging
        background: "lightgray",

    });
    getDeleteButtonStyle = () => ({
        float: 'right'
    })

    handleSwitchChange = (event, item) => {
        let displayType = "INTERNAL";
        if (event.target.checked) {
            displayType = "CUSTOMER";
        }
        var tempMap = this.state.misFieldLookUptable;
        if (tempMap && tempMap.has(item)) {
            let field = tempMap.get(item);
            field.displayType = displayType;
            tempMap.set(item, field);
        }

        this.setState({
            misFieldLookUptable: tempMap
        })
    }

    isCustomerDisplayable = (fieldName) => {

        if (this.state.misFieldLookUptable && this.state.misFieldLookUptable.has(fieldName)) {
            const temp = this.state.misFieldLookUptable.get(fieldName)
            if (temp && temp.displayType && temp.displayType === "CUSTOMER") {
                return "true";
            }
        }
        return null;
    }

    handleMandatoryMisOrderIdRadioChange = (event) => {
        this.setState({ isMandatoryMisOrderId: event.target.value === "true" });
    }



    render() {
        return (
            <Col>

                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0">
                        Mis Field Setup
                    </h5>
                </div>
                <div>
                    <FormGroup>
                        <div className="header-blue d-block p-2 text-primary font-weight-bold">
                        <Label>Choose Mis Form Fields
                        &nbsp;&nbsp;
                            <Button className="mx-1" size="sm" outline color="primary" title="Add" id="add" onClick={this.handleAdd}>
                                <i className="icon-plus"></i>Add
                            </Button>
                        </Label>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <Button  size="sm" outline color="primary" title="AddDefaultMisFields" id="addDefaultMisFields" onClick={this.handleAddDefaultMisFields}>
                                <i className="icon-plus"></i>Add Default MIS Fields
                            </Button>
                            </div>
                        
                    </FormGroup>
                </div>
                <Row>
                <Col>
                <div>
                    <Label className="header-blue d-block p-2 text-primary font-weight-bold">Selected Mis Form Fields</Label>
                </div>

                <div style={this.getListStyle()} >

                    {
                                       
                        this.state.selectedMisFieldNamesForDisplay.map(item => (
                            
                            <div key={item}>

                                <div className="card" style={this.getItemStyle()}>
                                    <div className="flex-display">
                                        <span className='text-primary font-weight-bold'>{item}</span>
                                        <Button style={this.getDeleteButtonStyle()} title="Remove" id="remove" className="float right justify-content-between align-items-center" color="danger" icon="fa-solid fa-arrow-right-to-bracket" onClick={e => this.handleDelete(e, item)} value={item}>
                                            <i className="icon-delete"></i>
                                        </Button>
                                    </div>
                                    <div className='flex-display'>
                                        <input type="checkbox" id="corporateDisplayCheckbox" checked={this.isCustomerDisplayable(item) ? true : false} onChange={e => this.handleSwitchChange(e, item)} />
                                        &nbsp;&nbsp;<span className='text-secondary font-weight-lighter'>Corporate Display</span>
                                    </div>

                                </div>

                            </div>
                        ))
                    }
                </div>
                </Col>
                    <Col>
                        <div className="d-flex align-items-center mt-4 mb-2">
                            <h5>OrderId Mandatory For Case Create:</h5>
                            <Label className='ml-5 '>
                                <Input
                                    type="radio"
                                    value="true"
                                    checked={this.state.isMandatoryMisOrderId === true}
                                    onChange={this.handleMandatoryMisOrderIdRadioChange}
                                />{' '}
                                Yes
                            </Label>
                            <Label className='ml-5 '>
                                <Input
                                    type="radio"
                                    value="false"
                                    checked={this.state.isMandatoryMisOrderId === false}
                                    onChange={this.handleMandatoryMisOrderIdRadioChange}
                                />{' '}
                                No
                            </Label>
                        </div>
                    </Col>
                </Row>

                <Modal show={this.state.showModal} modalClosed={this.toggleModal} >
                    {this.state.body}
                </Modal>
                <div>
                    <CorporateModal toShow={this.state.showCorporateModal} modalClosed={this.handleToggle} modalType={this.state.corporateModalType}
                        body={<Form >
                            <Row>
                                <Col >
                                    <FormGroup>
                                        <Label>Choose Mis Fields</Label>
                                        <MultiSelect data={this.props.misFieldList} selected={this.selectedEntityCallbackForMisFieldAddition} selectedValue={this.state.tempSelectedMisFields} />
                                    </FormGroup>
                                    <FormGroup>
                                        <Button className="btn btn-primary mt-3" onClick={this.handleAddMisFields} >Add</Button>
                                        <Button className="btn btn-danger mt-3 ml-3" onClick={this.handleCancel} >cancel</Button>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Form>}
                    />
                </div>
                
                <footer className="bg-light footer w-100 text-center">
                    <Button color="primary" onClick={this.handleMisNextButton}>
                        Next
                        &nbsp;&nbsp;<i className="fa fa-angle-double-right"></i>
                    </Button>
                </footer>
            </Col>
        )
    }
}


const mapStateToProps = (state, ownProps) => ({
    misFieldList: state.corporateOnBoardingCreate.fetchMisFieldListSuccess,
    misFieldSetupData: state.corporateOnBoardingCreate.misFieldSetupData,
    defaultMisFieldList: state.corporateOnBoardingCreate.fetchDefaultMisFieldListSuccess,
    fetchIsMisOrderIdMandatorySuccess: state.corporateOnBoardingCreate.fetchIsMisOrderIdMandatorySuccess,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    fetchMisFieldList: () => { dispatch(fetchMisFields()) },
    setMisFieldSetup: (data) => { dispatch(setMisFieldSetup(data)) },
    fetchMisFieldsByCorporateId: (data) => { dispatch(fetchMisFieldsByCorporateId(data)) },
    fetchDefaultMisFields: () => { dispatch(fetchDefaultMisFields()) },
    setIsMandatoryMisOrderId: (data) => { dispatch(setIsMandatoryMisOrderId(data)) },
    fetchIsMisOrderIdMandatoryByCorporateId: (data) => { dispatch(fetchIsMisOrderIdMandatoryByCorporateId(data)) },
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withAuth(MisFieldSetup));
